import useProvider from "./useProvider"

export default function useWorkerPermission(key) {
    const { permissions = [] } = useProvider()

    return permissions.includes(key)
}